// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/soc-frontend/" + chunkId + "." + {"4":"f13f0474","49":"65903710","81":"0e004632","223":"b60a1c21","325":"7600e933","682":"34c66292","905":"9df501db","967":"9acdab06"}[chunkId] + ".chunk.js";
};